/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { RiCloseLine } from 'react-icons/ri';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import DiscountCouponIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';

import { Backdrop, Box, Fade, Modal } from '@material-ui/core';
import { MdAttachMoney, MdMotorcycle } from 'react-icons/md';
import { formatDistance } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { SiMicrosoftexcel } from 'react-icons/si';
import { useExcelDownloder } from 'react-xls';
import ActivityIndicator from '../../components/ActivityIndicator';
import { useToast } from '../../hooks/toast';
import { getValidTimeZone } from '../../utils/companyDate';
import {
  HeaderPedido,
  ListProdutosWrapper,
  PedidoWrapper,
  ProdutoPedido,
} from '../MonitorPedidos/ContainerPrincipal/styles';
import BRLMoneyFormat from '../../utils/BRLMoneyFormat';
import mask from '../../utils/mask';
import PrinterReport from '../../components/ReportPrinter';
import { IOrder } from '../../interfaces/IOrder';
import { IDeliveryAddress } from '../../interfaces/IDeliveryAddress';
import { IPaymentMethod } from '../../interfaces/IPaymentMethod';
import { IOrderItem } from '../../interfaces/IOrderItem';
import OrdersService from '../../services/OrdersService';
import { useAuth } from '../../hooks/auth';
import APIError from '../../errors/APIError';
import { calcQtdSabores } from '../../utils/calcQtdSabores';

import IfoodImage from '../../assets/ifood.png';
import AtacImage from '../../assets/atac.png';
import IfoodService from '../../services/IfoodService';

export interface Data {
  pedido: number;
  data: string;
  type: string;
  cliente: string;
  fone: string;
  pagamento: string;
  valor: number;
  taxaEntrega: number;
  estagio: number;
  valortotal: number;
}

interface OrderTableProps {
  // orders: IPedidoVenda[];
  orders: Data[];
  onCancellation(pedido: number): void;
  timeZone?: string;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T): -1 | 0 | 1 {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = 'asc' | 'desc';

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string },
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number): T[] {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

const headCells: HeadCell[] = [
  { id: 'pedido', numeric: false, disablePadding: false, label: 'Pedido' },
  { id: 'data', numeric: false, disablePadding: false, label: 'Data' },
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    label: 'Plataforma',
  },
  { id: 'cliente', numeric: false, disablePadding: false, label: 'Cliente' },
  {
    id: 'pagamento',
    numeric: false,
    disablePadding: false,
    label: 'Pagamento',
  },
  {
    id: 'estagio',
    numeric: true,
    disablePadding: false,
    label: 'Estágio',
  },
  {
    id: 'valortotal',
    numeric: true,
    disablePadding: false,
    label: 'Valor Total',
  },
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    wrapper: {
      background: '#fff',
      borderRadius: 6,
      padding: 30,
      width: 585,
      overflow: 'auto',
      maxHeight: '90%',
    },
    modalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 30,
    },
    headerH1: {
      fontSize: 26,
      color: '#212121',
    },
    headerButton: {
      position: 'relative',
      background: 'transparent',
      border: 'none',
      color: '#d32f2f',
      padding: 5,
      borderRadius: 15,
      transition: 'all 0.35s ease-in-out',

      '&:hover': {
        color: '#b71c1c',
        transform: 'scale(1.125)',
      },
    },
    loading: {
      display: 'flex',
      justifyContent: 'center',
    },
    margin: {
      paddingBottom: 20,
    },
    minMargin: {
      paddingBottom: 10,
    },
    marginH3: {
      fontWeight: 700,
      paddingBottom: 5,
    },
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    cancelButton: {
      color: '#ffffff',
      backgroundColor: '#f44336',
      '&:hover': {
        backgroundColor: '#e57373',
      },
      '&:disabled': {
        backgroundColor: '#DDD',
      },
    },
    tableTitle: {
      marginBottom: '15px',
    },
    tableHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
);

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data,
  ) => void;
  order: Order;
  orderBy: string;
}

const formateBrPrice = (price: number): string =>
  price.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

function EnhancedTableHead(props: EnhancedTableProps): JSX.Element {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property: keyof Data) => (
    event: React.MouseEvent<unknown>,
  ) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align="center">Telefone</TableCell>
        <TableCell align="center">Detalhes</TableCell>
        <TableCell align="center">Cancelamento</TableCell>
        <TableCell align="center">Cancelado por</TableCell>
      </TableRow>
    </TableHead>
  );
}

const EnhancedTable: React.FC<OrderTableProps> = ({
  orders,
  onCancellation,
  timeZone,
}) => {
  const effectiveTimeZone = getValidTimeZone(timeZone);
  const estagios = [
    'Aguardo',
    'Aceito',
    'Negado',
    'Preparação',
    'Pronto',
    'Rota Entrega',
    'Entregue',
    'Faturado',
    'Separado',
    'Cancelado',
    'Cancelado Cliente',
    'Pronto retirada',
    'Em separação',
  ];
  const ifoodEstagios = {
    CANCELLED: 'Cancelado',
    CONCLUDED: 'Concluído',
    NOT_DEFINED: 'Não definido',
  };

  const { addToast } = useToast();
  const { user, caixa } = useAuth();

  const classes = useStyles();
  const [modalLoading, setModalLoading] = React.useState(true);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [ifoodModalOpen, setIfoodModalOpen] = React.useState(false);
  const [pdvModalOpen, setPdvModalOpen] = React.useState(false);
  const [currentPedido, setCurrentPedido] = React.useState<any>();
  const [ifoodOrder, setIfoodOrder] = React.useState<any>();
  const [pdvOrder, setPdvOrder] = React.useState<{
    displayId: number;
    customer: {
      name: string;
      phone: string;
    };
    paymentMethods: Array<{ description: string }>;
    orderItems: Array<{
      id: string;
      productName: string;
      quantity: number;
      totalPrice: number;
    }>;
    value: number;
    changeFor: number;
    observation: string;
  } | null>(null);

  const [orderV2, setOrderV2] = React.useState<
    | (Partial<IOrder> & {
        deliveryAddress?: Partial<IDeliveryAddress>;
        orderPayment: Partial<IPaymentMethod> & { companyPaymentMethod?: any };
        items: Partial<IOrderItem>[];
      })
    | null
  >(null);

  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('data');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const { ExcelDownloder, Type } = useExcelDownloder();

  const handleRequestSort = (
    _: React.MouseEvent<unknown>,
    property: keyof Data,
  ): void => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClick = (): void => {
    //
  };

  const handleCancellation = (pedido: number): void => {
    onCancellation(pedido);
  };

  const handleOpenDetailModal = async (pedido: any): Promise<void> => {
    setModalOpen(true);
    setCurrentPedido(pedido);

    try {
      setModalLoading(true);

      const response = await OrdersService.showOrder(
        user.empresa_id,
        caixa.id,
        pedido.pedido,
      );
      setOrderV2(response);

      setModalLoading(false);
    } catch (error) {
      console.log(error);
      if (error instanceof APIError) {
        addToast({
          title: error.message,
          type: 'error',
        });
        return;
      }
      addToast({
        title: 'Opss...',
        type: 'error',
        description:
          'Ocorreu um erro ao tentar obter as informações do pedido.',
      });

      setModalOpen(false);
      setCurrentPedido(undefined);
      setModalLoading(false);
    }
  };

  const handleOpenIfoodDetailModal = async (pedido: any): Promise<void> => {
    setIfoodModalOpen(true);
    setCurrentPedido(pedido);

    try {
      setModalLoading(true);

      const response = await IfoodService.getOrder(
        pedido.pedido,
        user.empresa_id,
      );

      setIfoodOrder(response);

      setModalLoading(false);
    } catch (error) {
      console.log(error);
      if (error instanceof APIError) {
        addToast({
          title: error.message,
          type: 'error',
        });
        return;
      }
      addToast({
        title: 'Opss...',
        type: 'error',
        description:
          'Ocorreu um erro ao tentar obter as informações do pedido.',
      });

      setIfoodOrder(undefined);
      setIfoodModalOpen(false);
      setCurrentPedido(undefined);
      setModalLoading(false);
    }
  };

  const handleOpenPdvDetailModal = async (pedido: any): Promise<void> => {
    setPdvModalOpen(true);
    setCurrentPedido(pedido);

    try {
      setModalLoading(true);

      const response = await OrdersService.showPdvOrder(
        user.empresa_id,
        pedido.pedido,
      );

      setPdvOrder(response);

      setModalLoading(false);
    } catch (error) {
      console.log(error);
      if (error instanceof APIError) {
        addToast({
          title: error.message,
          type: 'error',
        });
        return;
      }
      addToast({
        title: 'Opss...',
        type: 'error',
        description:
          'Ocorreu um erro ao tentar obter as informações do pedido.',
      });

      setPdvOrder(null);
      setPdvModalOpen(false);
      setCurrentPedido(undefined);
      setModalLoading(false);
    }
  };

  const handleChangePage = (_: unknown, newPage: number): void => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, orders.length - page * rowsPerPage);

  return (
    <div className={classes.root}>
      <Box className={classes.tableHeader}>
        <Typography
          variant="h6"
          id="tableTitle"
          component="div"
          className={classes.tableTitle}
        >
          Pedidos encontrados
        </Typography>

        <div style={{ display: 'flex', gap: 5 }}>
          <ExcelDownloder
            style={{
              padding: '5px',
              display: 'flex',
              alignItems: 'center',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              background: '#00BFA5',
            }}
            data={{
              orders: stableSort(orders, getComparator(order, orderBy)).map(
                (_order: any) => ({
                  DATA: `${new Date(
                    _order.data,
                  ).toLocaleDateString()} às ${new Date(
                    _order.data,
                  ).toLocaleTimeString()}`,
                  CLIENTE: _order.cliente,
                  TELEFONE:
                    _order.fone.length === 11
                      ? mask(_order.fone, '(##) #####-####')
                      : mask(_order.fone, '(##) ####-####'),
                  PAGAMENTO: _order.pagamento,
                  VALOR: _order.valor,
                  'TAXA DE ENTREGA': _order.taxaEntrega,
                  'VALOR DESCONTO': _order.valordesconto,
                  'VALOR TOTAL': _order.valortotal,
                  ESTÁGIO: estagios[_order.estagio || 0],
                }),
              ),
            }}
            filename={`historico-pedido-${new Date().getTime()}`}
            type={Type.Button}
          >
            Baixar em xls
            <SiMicrosoftexcel size={20} style={{ marginLeft: 5 }} />
          </ExcelDownloder>

          <PrinterReport
            className="print_btn"
            backgroundColor="transparent"
            textColor="#000"
            pedidos={stableSort(orders, getComparator(order, orderBy))}
          />
        </div>
      </Box>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="medium"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {stableSort(orders, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      onClick={handleClick}
                      role="checkbox"
                      tabIndex={-1}
                      key={row.pedido}
                    >
                      <TableCell component="th" id={labelId} align="center">
                        {row.type === 'ifood' ? '-' : row.pedido}
                      </TableCell>
                      <TableCell align="center" scope="row">
                        {new Date(row.data).toLocaleDateString('pt-BR', {
                          timeZone: effectiveTimeZone,
                        })}
                        <br />
                        às
                        <br />
                        {new Date(row.data).toLocaleTimeString('pt-BR', {
                          timeZone: effectiveTimeZone,
                        })}
                      </TableCell>
                      <TableCell align="center">
                        {row.type === 'ifood' ? (
                          <img src={IfoodImage} alt="ifood" />
                        ) : (
                          <img src={AtacImage} alt="atac" />
                        )}
                      </TableCell>
                      <TableCell align="center">{row.cliente}</TableCell>
                      <TableCell align="center">{row.pagamento}</TableCell>
                      <TableCell align="center">
                        {row.type === 'ifood'
                          ? ifoodEstagios[
                              String(row.estagio) as keyof typeof ifoodEstagios
                            ] || ifoodEstagios.NOT_DEFINED
                          : estagios[Number(row.estagio) || 0]}
                      </TableCell>
                      <TableCell align="center">{row.valortotal}</TableCell>
                      <TableCell align="center">
                        <p style={{ whiteSpace: 'nowrap' }}>
                          {row.fone.length === 11
                            ? mask(row.fone, '(##) #####-####')
                            : mask(row.fone, '(##) ####-####')}
                        </p>
                      </TableCell>
                      <TableCell align="center">
                        <Link
                          component="button"
                          onClick={() => {
                            if (row.type === 'ifood') {
                              handleOpenIfoodDetailModal(row);
                            } else if (row.type === 'pdv') {
                              handleOpenPdvDetailModal(row);
                            } else {
                              handleOpenDetailModal(row);
                            }
                          }}
                        >
                          Ver detalhes
                        </Link>
                      </TableCell>
                      <TableCell align="center">
                        {row.type === 'ifood' ? (
                          <span>-</span>
                        ) : (
                          <Button
                            onClick={() => handleCancellation(row.pedido)}
                            className={classes.cancelButton}
                            disabled={[2, 6, 7, 8, 9, 10].includes(row.estagio)}
                          >
                            Cancelar
                          </Button>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {/* eslint-disable-next-line no-nested-ternary */}
                        {row.estagio === 9
                          ? 'Loja'
                          : row.estagio === 10
                          ? 'Cliente'
                          : '-'}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={9} />
                </TableRow>
              )}
              <Modal
                className={classes.modal}
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={modalOpen}>
                  <div className={classes.wrapper}>
                    <div className={classes.modalHeader}>
                      <h1 className={classes.headerH1}>
                        Pedido n° {currentPedido?.pedido}
                      </h1>

                      <button
                        type="button"
                        className={classes.headerButton}
                        onClick={() => setModalOpen(false)}
                      >
                        <RiCloseLine size={30} />
                      </button>
                    </div>
                    {modalLoading || orderV2 === null ? (
                      <div className={classes.loading}>
                        <ActivityIndicator />
                      </div>
                    ) : (
                      <>
                        <div className={classes.margin}>
                          <h3 className={classes.marginH3}>
                            Informações do cliente
                          </h3>
                          <span>
                            {orderV2.customer?.tradingName ?? 'Venda balcão'}
                            {orderV2.deliveryAddress && (
                              <>
                                , {orderV2.deliveryAddress.address.logradouro},{' '}
                                {orderV2.deliveryAddress.address.numero},{' '}
                                {orderV2.deliveryAddress.address.bairro}
                              </>
                            )}
                          </span>
                          {orderV2.customer?.phoneNumber && (
                            <p style={{ fontWeight: 'bold' }}>
                              Contato:
                              <span style={{ fontWeight: 'normal' }}>
                                {` ${
                                  orderV2.customer.phoneNumber.length === 11
                                    ? mask(
                                        orderV2.customer.phoneNumber,
                                        '(##) #####-####',
                                      )
                                    : mask(
                                        orderV2.customer.phoneNumber,
                                        '(##) ####-####',
                                      )
                                }`}
                              </span>
                            </p>
                          )}
                        </div>
                        <div className={classes.margin}>
                          <h3 className={classes.marginH3}>
                            Detalhes do pedido
                          </h3>
                          <PedidoWrapper>
                            <HeaderPedido />
                            {orderV2.items.map((item) => (
                              <ListProdutosWrapper key={item.id}>
                                <ProdutoPedido>
                                  <div>
                                    <span>
                                      {item.portioned
                                        ? Number(item.quantity) >= 1
                                          ? Number(item.quantity).toFixed(3)
                                          : Number(item.quantity) *
                                            Number(
                                              item.measurementUnit[0]
                                                .quantityPortion,
                                            )
                                        : Number(item.quantity)}
                                      {item.portioned
                                        ? Number(item.quantity) >= 1
                                          ? item.measurementUnit[0].acronym
                                          : item.measurementUnit[0]
                                              .acronymPortion
                                        : 'x'}
                                    </span>
                                    {/* eslint-disable-next-line no-nested-ternary */}
                                    {item.sizeName !== null &&
                                    item.colorName === null ? ( // 2
                                      <p>
                                        Pizza{' '}
                                        {String(item.sizeName).toLowerCase()}
                                      </p>
                                    ) : item.sizeName !== null &&
                                      item.colorName !== null ? ( // 1
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'flex-start',
                                        }}
                                      >
                                        <p>{item.productName}</p>
                                        <p>
                                          {item.sizeName &&
                                            String(item.sizeName).toUpperCase()}
                                          {item.colorName &&
                                            ` - ${String(
                                              item.colorName,
                                            ).toUpperCase()}`}
                                        </p>
                                      </div>
                                    ) : (
                                      // 0
                                      <p>{item.productName}</p>
                                    )}
                                  </div>

                                  <span className="preco-produto">
                                    {Number(item.totalPrice).toLocaleString(
                                      'pt-BR',
                                      BRLMoneyFormat,
                                    )}
                                  </span>
                                </ProdutoPedido>
                                {!!item.observation && (
                                  <ProdutoPedido className="complemento observacao">
                                    <div className="obs-description">
                                      <span>Observação</span>
                                      <p>{item.observation}</p>
                                    </div>
                                  </ProdutoPedido>
                                )}
                                {item.childOrderItems?.map(
                                  (complemento, index, arr) => (
                                    <ProdutoPedido className="complemento">
                                      <div>
                                        <span>
                                          {!complemento.productGridName ? (
                                            Number(complemento.quantity)
                                          ) : (
                                            <>
                                              {Math.round(
                                                calcQtdSabores(
                                                  arr.filter(
                                                    (child) =>
                                                      !!child.productGridName,
                                                  ),
                                                ) *
                                                  Number(complemento.quantity),
                                              )}
                                              /
                                              {Math.round(
                                                calcQtdSabores(
                                                  arr.filter(
                                                    (child) =>
                                                      !!child.productGridName,
                                                  ),
                                                ),
                                              )}
                                            </>
                                          )}
                                        </span>
                                        <p>{complemento.productName}</p>
                                      </div>

                                      <span className="preco-produto">
                                        {Number(
                                          complemento.totalPrice,
                                        ).toLocaleString(
                                          'pt-BR',
                                          BRLMoneyFormat,
                                        )}
                                      </span>
                                    </ProdutoPedido>
                                  ),
                                )}
                              </ListProdutosWrapper>
                            ))}
                            <ProdutoPedido>
                              <div>
                                <MdMotorcycle size={20} />
                                <p>Taxa de entrega</p>
                              </div>
                              <span className="preco-produto">
                                {Number(orderV2.deliveryFee).toLocaleString(
                                  'pt-BR',
                                  BRLMoneyFormat,
                                )}
                              </span>
                            </ProdutoPedido>

                            {orderV2.discountCouponValue &&
                              +orderV2.discountCouponValue > 0 && (
                                <ProdutoPedido>
                                  <div>
                                    <DiscountCouponIcon />
                                    <p>Cupom de desconto: </p>
                                  </div>

                                  <span
                                    className="preco-produto"
                                    style={{ color: 'red' }}
                                  >
                                    {(
                                      +orderV2.discountCouponValue * -1
                                    ).toLocaleString('pt-BR', BRLMoneyFormat)}
                                  </span>
                                </ProdutoPedido>
                              )}

                            {orderV2.othersDiscountsValue &&
                              +orderV2.othersDiscountsValue > 0 && (
                                <ProdutoPedido>
                                  <div>
                                    <DiscountCouponIcon />
                                    <p>Outros descontos: </p>
                                  </div>

                                  <span
                                    className="preco-produto"
                                    style={{ color: 'red' }}
                                  >
                                    {(
                                      +orderV2.othersDiscountsValue * -1
                                    ).toLocaleString('pt-BR', BRLMoneyFormat)}
                                  </span>
                                </ProdutoPedido>
                              )}

                            {orderV2.orderPromotion?.length ? (
                              <ProdutoPedido>
                                <div>
                                  <DiscountCouponIcon />
                                  <p>
                                    Promoções - (
                                    {(
                                      (orderV2.orderPromotion ?? [])
                                        .map(
                                          (promotion: any) =>
                                            promotion.promotion.name,
                                        )
                                        .join('/')
                                    )}
                                    ):{' '}
                                  </p>
                                </div>

                                <span
                                  className="preco-produto"
                                  style={{ color: 'red' }}
                                >
                                  {Number(
                                    orderV2.orderPromotion?.reduce(
                                      (acc: number, cur: any) =>
                                        acc + +cur.total,
                                      0,
                                    ) * -1,
                                  ).toLocaleString('pt-BR', BRLMoneyFormat)}
                                </span>
                              </ProdutoPedido>
                            ) : null}

                            <ProdutoPedido>
                              <div>
                                <MdAttachMoney size={20} />
                                <p>Valor Total</p>
                              </div>
                              <span className="preco-produto">
                                {Number(orderV2.total).toLocaleString(
                                  'pt-BR',
                                  BRLMoneyFormat,
                                )}
                              </span>
                            </ProdutoPedido>
                          </PedidoWrapper>
                        </div>
                        {orderV2.observation && (
                          <div className={classes.margin}>
                            <h3>Obsevação</h3>
                            <p>{orderV2.observation}</p>
                          </div>
                        )}
                        {orderV2.deliveryStartedAt && orderV2.endedAt && (
                          <p className={classes.margin}>
                            Tempo de entrega:{' '}
                            <strong>
                              {formatDistance(
                                new Date(orderV2.deliveryStartedAt),
                                new Date(orderV2.endedAt),
                                {
                                  locale: ptBR,
                                },
                              )}
                            </strong>
                          </p>
                        )}

                        <div className={classes.margin}>
                          <p>
                            <strong>Tipo de entrega: </strong>
                            {/* eslint-disable-next-line no-nested-ternary */}
                            {orderV2?.logisticDelivery
                              ? 'Melhor envio'
                              : orderV2?.deliveryAddress
                              ? 'Entrega'
                              : 'Retirada balcão'}
                          </p>
                          {orderV2?.logisticDelivery && (
                            <>
                              <p>
                                <strong>Transportadora: </strong>
                                {orderV2.logisticDelivery.nome_transportadora}
                              </p>
                              <p>
                                <strong>Serviço: </strong>
                                {
                                  orderV2.logisticDelivery
                                    .nome_servico_transportadora
                                }
                              </p>
                              <p>
                                <strong>Valor: </strong>
                                {formateBrPrice(
                                  +orderV2.logisticDelivery.preco_custom,
                                )}
                              </p>
                              <p>
                                <strong>Tempo de entrega estimado: </strong>
                                {
                                  orderV2.logisticDelivery
                                    .estimativa_tempo_entrega
                                }{' '}
                                dias
                              </p>
                            </>
                          )}
                        </div>

                        <p className={classes.margin}>
                          Forma de pagamento:{' '}
                          <strong>
                            {
                              orderV2?.orderPayment.companyPaymentMethod
                                .paymentMethod.description
                            }
                          </strong>
                        </p>
                        {!!Number(orderV2.changeFor) && (
                          <p className={classes.margin}>
                            Troco:{' '}
                            <strong>
                              {Number(orderV2?.changeFor ?? 0).toLocaleString(
                                'pt-BR',
                                BRLMoneyFormat,
                              )}
                            </strong>
                          </p>
                        )}
                        {![0, 2, 9, 10].includes(orderV2.status!) && (
                          <>
                            <h3 className={classes.marginH3}>
                              Histórico de status
                            </h3>
                            {orderV2.endedAt && (
                              <p className={classes.minMargin}>
                                Concluído em:{' '}
                                <strong>
                                  {new Date(orderV2.endedAt).toLocaleString()}
                                </strong>
                              </p>
                            )}
                            {orderV2.deliveryStartedAt && (
                              <p className={classes.minMargin}>
                                Expedido em:{' '}
                                <strong>
                                  {new Date(
                                    orderV2.deliveryStartedAt,
                                  ).toLocaleString()}
                                </strong>
                              </p>
                            )}
                            {orderV2.tookAt && (
                              <p className={classes.minMargin}>
                                Retirado em:{' '}
                                <strong>
                                  {new Date(orderV2.tookAt).toLocaleString()}
                                </strong>
                              </p>
                            )}
                            {orderV2.preparationStartAt && (
                              <p className={classes.minMargin}>
                                Preparo iniciado em:{' '}
                                <strong>
                                  {new Date(
                                    orderV2.preparationStartAt,
                                  ).toLocaleString()}
                                </strong>
                              </p>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </Fade>
              </Modal>
              <Modal
                className={classes.modal}
                open={ifoodModalOpen}
                onClose={() => setIfoodModalOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={ifoodModalOpen}>
                  <div className={classes.wrapper}>
                    <div className={classes.modalHeader}>
                      <h1 className={classes.headerH1}>
                        Pedido n° {currentPedido?.pedido}
                      </h1>

                      <button
                        type="button"
                        className={classes.headerButton}
                        onClick={() => setIfoodModalOpen(false)}
                      >
                        <RiCloseLine size={30} />
                      </button>
                    </div>
                    {modalLoading || !ifoodOrder ? (
                      <div className={classes.loading}>
                        <ActivityIndicator />
                      </div>
                    ) : (
                      <>
                        <div className={classes.margin}>
                          <h3 className={classes.marginH3}>
                            Informações do cliente
                          </h3>
                          <span>
                            {ifoodOrder.customer?.name ?? 'Venda balcão'}
                            {ifoodOrder.orderType === 'DELIVERY' && (
                              <>
                                ,{' '}
                                {ifoodOrder.delivery.deliveryAddress.streetName}
                                ,{' '}
                                {
                                  ifoodOrder.delivery.deliveryAddress
                                    .streetNumber
                                }
                                ,{' '}
                                {
                                  ifoodOrder.delivery.deliveryAddress
                                    .neighborhood
                                }
                              </>
                            )}
                          </span>
                          {ifoodOrder.customer?.phone && (
                            <p style={{ fontWeight: 'bold' }}>
                              Contato:
                              <span style={{ fontWeight: 'normal' }}>
                                {` ${
                                  ifoodOrder.customer.phone.number.length === 11
                                    ? mask(
                                        ifoodOrder.customer.phone.number,
                                        '(##) #####-####',
                                      )
                                    : mask(
                                        ifoodOrder.customer.phone.number,
                                        '(##) ####-####',
                                      )
                                }`}
                              </span>
                            </p>
                          )}
                        </div>
                        <div className={classes.margin}>
                          <h3 className={classes.marginH3}>
                            Detalhes do pedido
                          </h3>
                          <PedidoWrapper>
                            <HeaderPedido />
                            {ifoodOrder.items.map((item: any) => (
                              <ListProdutosWrapper key={item.id}>
                                <ProdutoPedido>
                                  <div>
                                    <span>{Number(item.quantity)}</span>
                                    <p>{item.name}</p>
                                  </div>

                                  <span className="preco-produto">
                                    {Number(item.totalPrice).toLocaleString(
                                      'pt-BR',
                                      BRLMoneyFormat,
                                    )}
                                  </span>
                                </ProdutoPedido>
                                {!!item.observations && (
                                  <ProdutoPedido className="complemento observacao">
                                    <div className="obs-description">
                                      <span>Observação</span>
                                      <p>{item.observations}</p>
                                    </div>
                                  </ProdutoPedido>
                                )}
                                {item.options?.map((complemento: any) => (
                                  <ProdutoPedido className="complemento">
                                    <div>
                                      <span>
                                        {Number(complemento.quantity)}
                                      </span>
                                      <p>{complemento.name}</p>
                                    </div>

                                    <span className="preco-produto">
                                      {Number(complemento.price).toLocaleString(
                                        'pt-BR',
                                        BRLMoneyFormat,
                                      )}
                                    </span>
                                  </ProdutoPedido>
                                ))}
                              </ListProdutosWrapper>
                            ))}
                            <ProdutoPedido>
                              <div>
                                <MdMotorcycle size={20} />
                                <p>Taxa de entrega</p>
                              </div>
                              <span className="preco-produto">
                                {Number(
                                  ifoodOrder.total.deliveryFee,
                                ).toLocaleString('pt-BR', BRLMoneyFormat)}
                              </span>
                            </ProdutoPedido>

                            {ifoodOrder.total.benefits > 0 && (
                              <ProdutoPedido>
                                <div>
                                  <DiscountCouponIcon />
                                  <p>Descontos: </p>
                                </div>

                                <span
                                  className="preco-produto"
                                  style={{ color: 'red' }}
                                >
                                  {ifoodOrder.total.benefits.toLocaleString(
                                    'pt-BR',
                                    BRLMoneyFormat,
                                  )}
                                </span>
                              </ProdutoPedido>
                            )}

                            <ProdutoPedido>
                              <div>
                                <MdAttachMoney size={20} />
                                <p>Valor Total</p>
                              </div>
                              <span className="preco-produto">
                                {Number(
                                  ifoodOrder.total.orderAmount,
                                ).toLocaleString('pt-BR', BRLMoneyFormat)}
                              </span>
                            </ProdutoPedido>
                          </PedidoWrapper>
                        </div>
                        {ifoodOrder.delivery.observations && (
                          <div className={classes.margin}>
                            <h3>Obsevação</h3>
                            <p>{ifoodOrder.delivery.observations}</p>
                          </div>
                        )}

                        <div className={classes.margin}>
                          <p>
                            <strong>Tipo de entrega: </strong>
                            {ifoodOrder.orderType === 'DELIVERY'
                              ? 'Entrega'
                              : 'Retirada balcão'}
                          </p>
                        </div>

                        {ifoodOrder.payments.methods.map((method: any) => (
                          // eslint-disable-next-line no-underscore-dangle
                          <p className={classes.margin} key={method._id}>
                            Forma de pagamento:{' '}
                            <strong>
                              {/* eslint-disable-next-line no-nested-ternary */}
                              {method.method === 'CREDIT'
                                ? method.card.brand
                                : method.prepaid
                                ? 'Pago'
                                : 'Pendente'}
                            </strong>
                          </p>
                        ))}

                        {ifoodOrder.payments.methods.find(
                          (method: any) => method.method === 'CASH',
                        )?.cash.changeFor > 0 &&
                          ifoodOrder.payments.methods.find(
                            (method: any) => method.method === 'CASH',
                          )?.value > 0 && (
                            <>
                              <p className={classes.margin}>Troco: </p>
                              <strong>
                                {Number(
                                  Number(
                                    ifoodOrder.payments.methods.find(
                                      (method: any) => method.method === 'CASH',
                                    ).cash.changeFor,
                                  ) -
                                    ifoodOrder.payments.methods.find(
                                      (method: any) => method.method === 'CASH',
                                    ).value ?? 0,
                                ).toLocaleString('pt-BR', BRLMoneyFormat)}
                              </strong>
                            </>
                          )}
                      </>
                    )}
                  </div>
                </Fade>
              </Modal>
              <Modal
                className={classes.modal}
                open={pdvModalOpen}
                onClose={() => setPdvModalOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={pdvModalOpen}>
                  <div className={classes.wrapper}>
                    <div className={classes.modalHeader}>
                      <h1 className={classes.headerH1}>
                        Pedido n° {pdvOrder?.displayId || currentPedido?.pedido}
                      </h1>

                      <button
                        type="button"
                        className={classes.headerButton}
                        onClick={() => setPdvModalOpen(false)}
                      >
                        <RiCloseLine size={30} />
                      </button>
                    </div>
                    {modalLoading || !pdvOrder ? (
                      <div className={classes.loading}>
                        <ActivityIndicator />
                      </div>
                    ) : (
                      <>
                        <div className={classes.margin}>
                          <h3 className={classes.marginH3}>
                            Informações do cliente
                          </h3>
                          <span>
                            {pdvOrder.customer?.name ?? 'Venda balcão'}
                          </span>
                          {pdvOrder.customer?.phone && (
                            <p style={{ fontWeight: 'bold' }}>
                              Contato:
                              <span style={{ fontWeight: 'normal' }}>
                                {` ${
                                  pdvOrder.customer.phone.length === 11
                                    ? mask(
                                        pdvOrder.customer.phone,
                                        '(##) #####-####',
                                      )
                                    : mask(
                                        pdvOrder.customer.phone,
                                        '(##) ####-####',
                                      )
                                }`}
                              </span>
                            </p>
                          )}
                        </div>
                        <div className={classes.margin}>
                          <h3 className={classes.marginH3}>
                            Detalhes do pedido
                          </h3>
                          <PedidoWrapper>
                            <HeaderPedido />
                            {pdvOrder.orderItems.map((item) => (
                              <ListProdutosWrapper key={item.id}>
                                <ProdutoPedido>
                                  <div>
                                    <span>{Number(item.quantity)}</span>
                                    <p>{item.productName}</p>
                                  </div>

                                  <span className="preco-produto">
                                    {Number(item.totalPrice).toLocaleString(
                                      'pt-BR',
                                      BRLMoneyFormat,
                                    )}
                                  </span>
                                </ProdutoPedido>
                              </ListProdutosWrapper>
                            ))}

                            <ProdutoPedido>
                              <div>
                                <MdAttachMoney size={20} />
                                <p>Valor Total</p>
                              </div>
                              <span className="preco-produto">
                                {Number(pdvOrder.value).toLocaleString(
                                  'pt-BR',
                                  BRLMoneyFormat,
                                )}
                              </span>
                            </ProdutoPedido>
                          </PedidoWrapper>
                        </div>
                        {pdvOrder.observation && (
                          <div className={classes.margin}>
                            <h3>Observação</h3>
                            <p>{pdvOrder.observation}</p>
                          </div>
                        )}

                        {pdvOrder.paymentMethods?.map((method, index) => (
                          <p
                            className={classes.margin}
                            key={`payment-${index}`}
                          >
                            Forma de pagamento:{' '}
                            <strong>{method.description}</strong>
                          </p>
                        ))}

                        {!!Number(pdvOrder.changeFor) && (
                          <p className={classes.margin}>
                            Troco:{' '}
                            <strong>
                              {Number(pdvOrder.changeFor).toLocaleString(
                                'pt-BR',
                                BRLMoneyFormat,
                              )}
                            </strong>
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </Fade>
              </Modal>
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={orders.length}
          rowsPerPage={rowsPerPage}
          page={page}
          labelRowsPerPage="Pedidos por página:"
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
};

export default EnhancedTable;
